import React from 'react'
import { rem } from 'polished'

import ImageWithReservedSpace from 'components/Common/ImageWithReservedSpace'
import InlineGroup from 'components/Common/InlineGroup'
import BodyText from 'components/Luxkit/Typography/BodyText'
import styled from 'styled-components'

const PackageDetails = styled.div`
  margin-left: ${rem(16)};
`

interface Props {
  image: App.Image;
  packageName: string;
  roomTypeName: string;
}

export function BnblPackageImageAndName({ image, packageName, roomTypeName }: Props) {
  return (
    <InlineGroup vertical="center">
      <ImageWithReservedSpace
        id={image.id}
        alt={image.title}
        withPlaceholder
        xs="1:1"
        xsWidth={rem(96)}
      />
      <PackageDetails>
        <BodyText weight="bold" variant="large">{packageName}</BodyText>
        <BodyText variant="large">{roomTypeName}</BodyText>
      </PackageDetails>
    </InlineGroup>
  )
}
